import { useQuery } from '@apollo/client';
import { GRAPHQL_USUARIO_PERMISSOES } from 'gql/usuario';
import { useMemo } from 'react';
import { usePermissao } from 'hooks/usePermissao';
interface IPerfil {
    id?: number;
    administrador?: boolean;
}
interface IQuery {
    perfil?: IPerfil[];
}
interface IProps {
    searchResourceId?: string;
    /** @deprecated ignorado: a permissão agora é `<searchResourceId>.agrupar` */
    action?: string;
}
export const useQueryPermissions = ({
    searchResourceId = 'lista-coleta',
}: IProps = {}) => {
    const { can } = usePermissao();
    const { data } = useQuery<IQuery>(GRAPHQL_USUARIO_PERMISSOES);
    const administrador = useMemo(() => {
        if (data?.perfil && data?.perfil.length > 0) {
            const indiceAdministrador = data?.perfil.findIndex(
                ({ administrador }) => administrador
            );
            return indiceAdministrador !== -1;
        }
        return false;
    }, [data]);

    const perfilAdministrador = useMemo(() => {
        if (data?.perfil && data?.perfil.length > 0) {
            const indiceAdministrador = data?.perfil.findIndex(
                ({ id }) => id === 1
            );
            return indiceAdministrador !== -1;
        }
        return false;
    }, [data]);
    const perfilUnidadeAdministrador = useMemo(() => {
        if (data?.perfil && data?.perfil.length > 0) {
            const indiceAdministrador = data?.perfil.findIndex(
                ({ id }) => id === 2
            );
            return indiceAdministrador !== -1;
        }
        return false;
    }, [data]);

    const agrupavel = can(`${searchResourceId}.agrupar`);

    return {
        agrupavel,
        administrador,
        perfilAdministrador,
        perfilUnidadeAdministrador,
    };
};
